export const ACCESS_MARK_MAX_WIDTH = 110;
export const ACCESS_MARK_POINT_SIZE = 25;
export const ACCESS_GRID_BREAKPOINT = 'md';
